// Zoom for images in the Files viewer (OL-241). 1 means "fit the whole image
// in the window"; bigger numbers enlarge it from there and the viewer scrolls.

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 5;
const STEP = 1.25;

export const clampZoom = (zoom) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, Number(zoom) || MIN_ZOOM));

/** One step in (`direction` > 0) or out (< 0), landing exactly on Fit and the cap. */
export const stepZoom = (zoom, direction) => {
  const next = direction > 0 ? zoom * STEP : zoom / STEP;
  // Snap near-1 values so stepping out always comes back to exactly Fit.
  return Math.abs(next - 1) < 0.01 ? 1 : clampZoom(Math.round(next * 100) / 100);
};

export const zoomLabel = (zoom) => (zoom <= MIN_ZOOM ? 'Fit' : `${Math.round(zoom * 100)}%`);

/**
 * The width to draw an image at: the size that fits it whole in the box (never
 * enlarging a small image), times the zoom. Null until both sizes are known.
 */
export const zoomedWidth = ({ naturalWidth, naturalHeight, boxWidth, boxHeight, zoom }) => {
  if (!naturalWidth || !naturalHeight || !boxWidth || !boxHeight) return null;
  const fit = Math.min(boxWidth / naturalWidth, boxHeight / naturalHeight, 1);
  // Rounded down: rounding up made a fitted image 1px taller than the box, and it scrolled.
  return Math.floor(naturalWidth * fit * clampZoom(zoom));
};
